import WelcomeJoin from './WelcomeJoin.jsx';

export default WelcomeJoin;
